import React, { useEffect } from 'react'
import DashboardLayout from './layout/DashboardLayout'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AppRoutes } from './utils/constants'
import { SearchContextProvider } from './contexts/searchContext'
import Products from './pages/Products/Products'
import Sales from './pages/Sales/Sales'
import Templates from './pages/Templates/Templates'
import { ProfileContextProvider } from './contexts/profileContext'
import Home from './pages/Home/Home'
import Contacts from './pages/Contacts/Contacts'
import { PrivateRoute } from './layout/PrivateRoute'
import WebsiteBuilder from './pages/Website/WebsiteBuilder'
import NotFound from './pages/Common/NotFound'
import { useUsermaven } from '@usermaven/react'
import { TemplateContextProvider } from './contexts/templateContext'
import Automations from './pages/Automations/Automations'
import ForgotPassword from './pages/Login/ForgotPassword'
import Login from './pages/Login/Login'
import Register from './pages/Login/Register'
import BillingSettings from './pages/Settings/Billing/BillingSettings'
import IntegrationSettings from './pages/Settings/Integration/IntegrationSettings'
import Settings from './pages/Settings/Account/Settings'
import Edit from './pages/Templates/Edit'
import Appointments from './pages/Appointments/Appointments'
import { UnipileContextProvider } from './contexts/unipileContext'
import Profile from './pages/Profile/Profile'
import TeamSettings from './pages/Settings/Team/TeamSettings'
import AppointmentTypeSettings from './pages/Settings/Appointment/AppointmentTypesSettings'

function App() {
  const { trackPageView } = useUsermaven()

  useEffect(() => {
    trackPageView()
  }, [trackPageView])

  return (
    <div className="App">
      <Routes>
        <Route
          path={AppRoutes.root}
          element={<Navigate to={AppRoutes.login} />}
        />
        <Route path={AppRoutes.login} element={<Login />} />
        <Route path={AppRoutes.register} element={<Register />} />
        <Route path={AppRoutes.forgotPassword} element={<ForgotPassword />} />
        <Route
          element={
            <SearchContextProvider>
              <DashboardLayout />
            </SearchContextProvider>
          }
        >
          <Route element={<PrivateRoute />}>
            <Route path={AppRoutes.home} element={<Home />} />
            <Route path={AppRoutes.contacts} element={<Contacts />} />
            <Route
              path={AppRoutes.contactProfile}
              element={
                <ProfileContextProvider>
                  <Profile />
                </ProfileContextProvider>
              }
            />
            <Route path={AppRoutes.products} element={<Products />} />
            <Route path={AppRoutes.appointments} element={<Appointments />} />
            <Route path={AppRoutes.sales} element={<Sales />} />
            <Route path={AppRoutes.templates} element={<Templates />} />
            <Route
              path={AppRoutes.editTemplate}
              element={
                <TemplateContextProvider>
                  <Edit />
                </TemplateContextProvider>
              }
            />
            <Route path={AppRoutes.automations} element={<Automations />} />
            <Route path={AppRoutes.settings} element={<Settings />} />
            <Route
              path={AppRoutes.appointmentSettings}
              element={<AppointmentTypeSettings />}
            />
            <Route
              path={AppRoutes.integrationSettings}
              element={
                <UnipileContextProvider>
                  <IntegrationSettings />
                </UnipileContextProvider>
              }
            />
            <Route path={AppRoutes.teamSettings} element={<TeamSettings />} />
            <Route path={AppRoutes.billing} element={<BillingSettings />} />
            <Route
              path={AppRoutes.websiteBuilder}
              element={<WebsiteBuilder />}
            />
          </Route>
        </Route>
        <Route path={AppRoutes.notFound} element={<NotFound />} />
      </Routes>
    </div>
  )
}

export default App
